<template>
  <div class="ApplyCreditForm">
    <NavHeaderBar title="快速申请" leftArrow rightArrow />

    <van-form ref="form" style="padding: 10px;" @submit="onSubmit">
      <van-field
        v-model="form.name"
        name="name"
        label="真实姓名"
        placeholder="确认后无法修改"
        required
        :rules="[{ required: true, message: '请输入真实姓名' }]"
      />

      <van-field
        label="申请分数"
        name="amount"
        required
        :rules="[{ validator: validatorAmount, message: '请选择申请分数' }]"
      >
        <template #input>
          <van-stepper
            v-model="form.amount"
            integer
            :min="0"
            :max="maxAmount"
          />
        </template>
      </van-field>

      <van-field
        name="sex"
        label="性别"
        :rules="[{ required: false, message: '请填写性别' }]"
      >
        <template #input>
          <van-radio-group v-model="form.sex" direction="horizontal">
            <van-radio :name="1">男</van-radio>
            <van-radio :name="2">女</van-radio>
          </van-radio-group>
        </template>
      </van-field>

      <van-field
        v-model="form.mobile"
        type="tel"
        name="mobile"
        placeholder="确认后无法修改"
        label="手机号"
        required
        :rules="[
          {
            pattern: /^((13[0-9])|(14[0-9])|(15[0-9])|(16[0-9])|(17[0-9])|(18[0-9])|(19[0-9]))\d{8}$/,
            message: '请填写正确的手机号'
          }
        ]"
      />

      <van-field
        v-model="form.idcard"
        name="idcard"
        label="身份证号"
        placeholder="确认后无法修改"
        required
        :rules="[
          { required: true, message: '请输入身份证号' },
          {
            pattern: /^([1-6][1-9]|50)\d{4}(18|19|20)\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
            message: '身份证号格式错误！'
          }
        ]"
      />

      <van-field
        v-model="form.iccard"
        name="iccard"
        label="IC卡号"
        placeholder="确认后无法修改"
        required
        :rules="[{ required: true, message: '请输入IC卡号' }]"
      />

      <van-field
        name="jobtitle"
        label="职称"
        placeholder="请选择"
        :rules="[{ required: true, message: '请选择职称' }]"
        readonly
        required
        clickable
        v-model="form.jobtitle"
        @click="showPicker = true"
      />
      <van-popup v-model="showPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="jisdjs"
          @confirm="onJisdjConfirm"
          @cancel="showPicker = false"
        />
      </van-popup>

      <van-field
        v-model="form.danwei"
        name="danwei"
        label="工作单位"
        placeholder="请输入"
        required
        :rules="[{ required: true, message: '请输入工作单位' }]"
      />

      <van-field
        v-model="form.office"
        name="office"
        label="所属科室"
        placeholder="请输入"
        required
        :rules="[{ required: true, message: '请输入所属科室' }]"
      />

      <van-field
        name="shenshi"
        label="所在省市"
        placeholder="请选择"
        :rules="[{ required: true, message: '请选择您所在的省市' }]"
        readonly
        clickable
        required
        v-model="form.shenshi"
        @click="showArea = true"
      />
      <van-popup v-model="showArea" position="bottom">
        <van-area
          :area-list="areaList"
          @confirm="onAreaConfirm"
          @cancel="showArea = false"
        />
      </van-popup>

      <van-field
        name="destflag"
        label="是否西部或特困地区"
        :rules="[{ required: false, message: '请选择' }]"
      >
        <template #input>
          <van-radio-group v-model="form.destflag" direction="horizontal">
            <van-radio :name="1">是</van-radio>
            <van-radio :name="2">否</van-radio>
          </van-radio-group>
        </template>
      </van-field>

      <van-field
        v-model="form.email"
        name="email"
        label="电子邮箱"
        placeholder="请输入"
      />

      <div style="margin: 16px;">
        <van-button round block type="info" native-type="submit"
          >提交</van-button
        >
      </div>
    </van-form>
  </div>
</template>

<script>
import { areaList } from "@vant/area-data";
import apis from "@/config/apis";
export default {
  name: "ApplyCreditForm",
  computed: {
    maxAmount() {
      return this.$route.params.max;
    },
    source() {
      return this.$route.params.source;
    }
  },
  data: () => ({
    form: {
      name: "",
      sex: "",
      danwei: "",
      office: "",
      shenshi: "",
      destflag: "",
      idcard: "",
      iccard: "",
      mobile: "",
      jobtitle: "",
      province: "",
      city: "",
      amount: 0
    },
    areaList,
    showArea: false,
    showPicker: false,
    jisdjs: [
      "主任医师",
      "主任药师",
      "主任护师",
      "主任技师",
      "副主任医师",
      "副主任药师",
      "副主任护师",
      "副主任技师",
      "主治（主管）医师",
      "主管药师",
      "主管护师",
      "主管技师",
      "医师、医士",
      "药师、药士",
      "护师、护士",
      "技师、技士",
      "其他"
    ]
  }),
  methods: {
    validatorAmount(val) {
      console.log(val, this.form.amount);
      return val !== 0;
    },
    async onSubmit() {
      try {
        const params = { ...this.form, source: this.source };
        params.creditType = this.$route.params.id;
        const { success, data, msg } = await apis.credit.applyCredit(params);
        if (success === "ok" && data) {
          this.$toast.success(msg);
          setTimeout(() => {
            this.$router.push("/myCredit");
          }, 600);
        } else {
          this.$toast.success(msg);
        }
      } catch (error) {
        console.log(error);
      }
    },
    onAreaConfirm(values) {
      this.form.province = values[0].name;
      this.form.city = values[1].name;
      this.form.shenshi = values
        .filter(item => !!item)
        .map(item => item.name)
        .join("/");
      this.showArea = false;
    },
    onJisdjConfirm(value) {
      this.form.jobtitle = value;
      this.showPicker = false;
    }
  }
};
</script>

<style lang="scss">
.ApplyCreditForm {
  padding-top: 46px;
}
</style>
